import React from 'react';

import AssistanceLandingSeekingCountries from './AssistanceLandingSeekingCountries';
import AssistanceLandingProvidedOECD from './AssistanceLandingProvidedOECD';
import AssistanceLandingText from './AssistanceLandingText';
import {
  assistanceTopics,
  defaultAssistanceColor,
} from '../../resources/thematic-topics';

class AssistanceLading extends React.Component {
  render() {
    return (
      <div>
        <div>
          <AssistanceLandingText />
        </div>

        <div className="panel panel-default assistance-page-panel">
          <div className="panel-heading">
            <h3 style={{ display: 'inline' }}>International cooperation and assistance</h3>
            <div className="assistance-page-panel__header-subtitle">Data source: POA reporting</div>
          </div>
          <div className="panel-body">
            <AssistanceLandingSeekingCountries
              thematicDict={assistanceTopics}
              defaultColor={defaultAssistanceColor}
            />
          </div>
        </div>

        <div className="panel panel-default assistance-page-panel">
          <div className="panel-heading">
            <h3 style={{ display: 'inline' }}>
              Assistance provided <small>by OECD states</small>{' '}
            </h3>
            <div className="assistance-page-panel__header-subtitle">Data source: OECD</div>
          </div>
          <div className="panel-body">
            <AssistanceLandingProvidedOECD />
          </div>
        </div>
      </div>
    );
  }
}

export default AssistanceLading;



// WEBPACK FOOTER //
// ./src/components/AssistanceLanding/AssistanceLanding.js